import { InjectionToken } from '@angular/core';
import { ExControlConfig } from '../model/controls';

function requiredError(configVarName: string, tokenDefName: string) {
  return () => {
    throw new Error(
      `Value for "${configVarName}" configuration was not set but is required! Set "${tokenDefName}" injection token in your module."`,
    );
  };
}

export const USE_VERIFICATION_DATABASE = new InjectionToken<boolean>('useVerificationDatabase', { factory: () => false });
export const USE_VERIFICATION_MANUAL_LIGHT = new InjectionToken<boolean>('useVerificationManualLight', { factory: () => false });
export const USE_VERIFICATION_UPPER_MRZ = new InjectionToken<boolean>('useVerificationUpperMRZ', { factory: () => false });
export const USE_VERIFICATION_EAC = new InjectionToken<boolean>('useVerificationEAC', { factory: () => false });

export const USE_ANIMATIONS = new InjectionToken<boolean>('useAnimations', { factory: () => false });
export const USE_VISIBLE_BACKDROP = new InjectionToken<boolean>('useVisibleBackdrop', { factory: () => false });

export const FINGERPRINT_QUALITY_LIMIT_FOR_ENROLL = new InjectionToken<number>('fingerprintQualityLimitForEnroll', { factory: () => 0 });
export const FINGERPRINT_QUALITY_LIMIT_FOR_MATCH = new InjectionToken<number>('fingerprintQualityLimitForMatch', { factory: () => 0 });
export const FINGERPRINT_MATCH_THRESHOLD = new InjectionToken<number>('fingerprintMatchThreshold', { factory: () => 0 });

export const MRZ_ACTIVE_LINE = new InjectionToken<[number, number]>('mrzActiveLine', {
  factory: requiredError('mrzActiveLine', 'MRZ_ACTIVE_LINE'),
});
export const MRZ_RESOLUTION = new InjectionToken<[number, number]>('mrzResolution', {
  factory: requiredError('mrzResolution', 'MRZ_RESOLUTION'),
});

export const ENABLE_VALIDATION_PROFILER = new InjectionToken<boolean>('validationProfilerEnabled', { factory: () => false });
export const ENABLE_SIGNATURE_DEBUG = new InjectionToken<boolean>('debugSignature', { factory: () => false });

export const USE_USB_PASSPORT_READER = new InjectionToken<boolean>('useUsbPassportReader', { factory: () => false });

export const EX_CONTROL_CONFIG = new InjectionToken<ExControlConfig>('exControlConfig', { factory: () => ({ type: 'default' }) });
